import { render, staticRenderFns } from "./JumboTron.vue?vue&type=template&id=5bbd1982&scoped=true"
import script from "./JumboTron.vue?vue&type=script&lang=js"
export * from "./JumboTron.vue?vue&type=script&lang=js"
import style0 from "./JumboTron.vue?vue&type=style&index=0&id=5bbd1982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd1982",
  null
  
)

export default component.exports